import type {
  AuthenticationLevel,
  HirerAuthProvider,
} from '@seek/hirer-auth-react';
import type { ComponentProps } from 'react';

import { Environment } from 'src/types';

interface Options {
  environment: Environment;
}

// @ts-expect-error Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
const isEnvMocked = () => global.USE_STAGING_ENV_FOR_LOCAL !== 'true';

export const getHirerAuthProviderProps = (
  options: Options,
): Omit<ComponentProps<typeof HirerAuthProvider>, 'children'> => {
  const authenticationLevel: AuthenticationLevel =
    options.environment === Environment.Development && isEnvMocked()
      ? 'Mocked'
      : 'Hirer';

  return {
    authenticationLevel,
  };
};
